export default __webpack_public_path__ + "re_landscape-800-392aa59f1daf5ce19151e0d3a239787a.png";